// TODO: standarize on API across all lists, so that overwriting params is minimised,
// TODO: add different variants (multi-select & ID-based, or single-select & string-based)
import api from '@/api';
import store from '@/store';
import Vue from 'vue';
import uniqBy from 'lodash/uniqBy';
import { formatItemIdentity } from '@/helpers/formatters';
import { isObject } from 'lodash';

const vm = new Vue({ data () { return { models: {} }; } });

const generateName = (...args) => JSON.stringify(args);

export function separateAlternativeModels (models = {}, fields = [], removeFields = []) {
    return Object.keys(models)
        .filter(key => !removeFields.includes(key))
        .reduce((outputModel, modelName) => {
            const schema = fields.find((field) => field.name === modelName);

            if (schema && schema.type === 'multiselect' && schema.alternativeModelName) {
                const originalModel = models[modelName];
                const separatedAlternativeModel = {
                    [schema.alternativeModelName]: originalModel.filter((item) => typeof item === (schema.alternativeModelType || 'number') && item),
                };
                const strippedOriginalModel = { [modelName]: originalModel.filter((item) => typeof item !== (schema.alternativeModelType || 'number') && item) };

                outputModel = { ...outputModel, ...strippedOriginalModel, ...separatedAlternativeModel };
            } else {
                outputModel[modelName] = models[modelName];
            }
            return outputModel;
        }, {});
}

export function reduceLocalFiltersFromModels (models = {}, removeFields = []) {
    return Object.keys(models)
        .filter(key => !removeFields.includes(key))
        .reduce((model, key) => {
            model[key] = models[key];
            return model;
        }, {});
}

export function filterStatus (params = {}) {
    return {
        name: 'status',
        type: 'multiselect',
        placeholder: 'Status',
        label: 'Status',
        options: [
            { key: '1', label: 'Enabled' },
            { key: '0', label: 'Disabled' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}


export function filterName (params = {}) {
    return {
        name: 'name',
        placeholder: 'Name',
        label: 'Name',
        ...params,
    };
}

export function filterCountry (params = {}) {
    const modelName = generateName('filterCountry', ...arguments);

    return {
        name: 'country',
        placeholder: 'Countries',
        label: 'Countries',
        type: 'multiselect',
        multiple: true,
        options: () => vm.models[modelName],
        key: 'code',
        text: 'code',
        optionTemplate: country => country.display_name,
        searchChange: (query) => api.client.cancel() && api.dicts.countries({ display_name: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
        onInputSelect: () => {
            vm.$set(vm.models, modelName, store.getters.countries);
        },
        ...params,
    };
}

export function filterOffer (params = {}) {
    const modelName = generateName('filterOffer', ...arguments);
    return {
        name: 'offer_name',
        type: 'multiselect',
        multiple: false,
        options: () => vm.models[modelName] && vm.models[modelName].map(offer => ({
            key: offer.id,
            label: offer.name,
        })),
        key: 'key',
        text: 'label',
        searchChange: (query) => query && api.client.cancel() && api.offers.dict({ limit: 200, [params.searchKey || 'name']: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
        placeholder: 'Offer',
        label: 'Offer',
        ...params,
    };
}

export function filterOfferType (params = {}) {
    return {
        name: 'type_id',
        placeholder: 'Offer Type',
        label: 'Offer Type',
        type: 'multiselect',
        multiple: true,
        options: () => store.getters.offerTypes.map(elem => ({ label: elem.name, key: elem.stringId })),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterOnlyActive (params = {}) {
    return {
        name: 'only_active',
        placeholder: 'Only active',
        label: 'Only active',
        type: 'switch',
        activeValue: 1,
        inactiveValue: 0,
        ...params,
    };
}

export function filterOfferCategories (params = {}) {
    const modelName = generateName('filterOfferCategories', ...arguments);

    return {
        name: 'categories',
        type: 'multiselect',
        multiple: true,
        label: 'Categories',
        placeholder: 'Categories',
        options: () => vm.models[modelName],
        key: 'id',
        text: 'name',
        onInputSelect: () => !vm.models[modelName] && api.dicts.categories({ limit: -1 })
            .then(({ data }) => vm.$set(vm.models, modelName, data.data)),
        ...params,
    };
}

export function filterOs (params = {}) {
    const modelName = generateName('filterOs', ...arguments);
    return {
        name: 'os',
        placeholder: 'OS',
        label: 'OS',
        type: 'multiselect',
        multiple: true,
        options: () => vm.models[modelName],
        key: 'value',
        text: 'value',
        onInputSelect: () => !vm.models[modelName] && api.tags.tagsOS({ limit: -1 })
            .then(({ data }) => vm.$set(vm.models, modelName, data.data)),
        ...params,
    };
}

export function filterSkadOs (params = {}) {
    return {
        name: 'os',
        placeholder: 'OS',
        label: 'OS',
        type: 'multiselect',
        options: () => store.getters.osDictSkad,
        key: 'value',
        text: 'value',
        ...params,
    };
}

export function filterHandset () {
    const modelName = generateName('filterHandset', ...arguments);

    return {
        name: 'handset',
        type: 'multiselect',
        label: 'Handset',
        multiple: true,
        placeholder: 'Enter tag(s) here',
        options: () => vm.models[modelName],
        key: 'value',
        text: 'value',
        searchChange: (query) => query && api.client.cancel() && api.tags.tagsHandset({ limit: 30, value: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
    };
}

export function filterTrafficType (params = {}) {
    return {
        name: 'traffic_type_id',
        placeholder: 'Traffic Type',
        label: 'Traffic Type',
        type: 'multiselect',
        options: () => store.getters.trafficTypes.map(elem => ({ label: elem.name, key: elem.id })),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterPartnerTrafficType (params = {}) {
    return {
        name: 'traffic_types',
        type: 'multiselect',
        multiple: true,
        placeholder: 'Traffic Type',
        label: 'Traffic Type',
        options: () => store.getters.partnersTrafficTypes,
        key: 'string_id',
        text: 'name',
        ...params,
    };
}

export function filterTrafficHasOwn (params = {}) {
    return {
        type: 'multiselect',
        name: 'traffic_has_own',
        label: 'Has own traffic',
        placeholder: 'Has own traffic',
        multiple: false,
        options: () => [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterTrafficDailyClickVolume (params = {}) {
    return {
        name: 'traffic_daily_click_volume',
        label: 'Traffic daily click volume',
        placeholder: 'Traffic daily click volume',
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterAdvertiser (params = {}) {
    const modelName = generateName('filterAdvertiser', ...arguments);
    return {
        name: 'advertiser_id',
        placeholder: 'Advertisers',
        label: 'Advertisers',
        type: 'multiselect',
        multiple: true,
        options: () => vm.models[modelName] && vm.models[modelName].map(advertiser => ({
            key: advertiser.id,
            label: advertiser.short,
        })),
        searchChange: (query) => query && api.client.cancel() && api.advertisers.dict({ limit: 200, [params.searchKey || 'short']: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterExternalIntegration (params = {}) {
    const modelName = generateName('filterExternalIntegration', ...arguments);
    return {
        name: 'external_integration_id',
        placeholder: 'Integration Name',
        label: 'Integration Name',
        type: 'multiselect',
        multiple: true,
        options: () => vm.models[modelName],
        onInputSelect: () => !vm.models[modelName] && api.config.listExternalIntegrations({ limit: -1 })
            .then(({ data }) => {
                const options = data.data.map(config => ({
                    key: config.id,
                    label: config.title,
                }));
                return vm.$set(vm.models, modelName, options);
            }),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterAdvertiserSearch (params = {}) {
    return {
        name: 'search',
        placeholder: 'Name or ID',
        label: 'Advertiser',
        ...params,
    };
}

export function filterAdvertiserIdOrName (params = {}) {
    const modelId = generateName('filterAdvertiserIdOrName', params);
    const optionsStored = generateName('filterAdvertiserIdOrName-all', params);
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'advertiser_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Advertiser',
        searchChange: (query) => query && api.client.cancel() && api.advertisers.dict({ limit: 200, search: query, ...requestParams })
            .then(({ data }) => {
                if (!data) return;
                let options = data.data.map(advertiser => ({
                    key: advertiser.id,
                    label: formatItemIdentity(advertiser, { infoField: 'short' }),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        parents: 'advertiser',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterAdvertiserType (params = {}) {
    return {
        name: 'type_id',
        placeholder: 'Type',
        label: 'Type',
        type: 'multiselect',
        options: [
            { key: '1', name: 'Internal' },
            { key: '2', name: 'External' },
        ],
        key: 'key',
        text: 'name',
        ...params,
    };
}

export function filterTrackingId (params = {}) {
    return {
        name: 'tsp',
        placeholder: 'Tracking ID',
        label: 'Tracking ID',
        ...params,
    };
}

export function filterIP (params = {}) {
    return {
        name: 'ip',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        placeholder: 'IP (exact)',
        label: 'IP (exact)',
        ...params,
    };
}

export function filterWhitelistIpTypes (params = {}) {
    return {
        name: 'type',
        type: 'multiselect',
        multiple: true,
        placeholder: 'Type',
        label: 'Type',
        options: () => store.getters.whitelistIpTypes,
        key: 'code',
        text: 'name',
        ...params,
    };
}

export function filterOfferByExternalId (params = {}) {
    return {
        name: 'external_id',
        placeholder: 'External ID',
        label: 'External ID',
        ...params,
    };
}

export function filterYdrid (params = {}) {
    return {
        name: 'ydrid',
        placeholder: 'Ydrid',
        label: 'Ydrid',
        ...params,
    };
}

export function filterAffpubid (params = {}) {
    return {
        type: 'multiselect',
        name: 'affpubid',
        placeholder: 'Affpubid',
        label: 'Affpubid',
        taggable: true,
        multiple: true,
        key: 'affpubid',
        text: 'affpubid',
        ...params,
    };
}

export function filterPartner (params = {}, searchParams = {}) {
    const modelName = generateName('filterPartner', ...arguments);
    return {
        name: 'partner_id',
        type: 'multiselect',
        placeholder: 'Publishers',
        label: 'Publishers',
        options: () => vm.models[modelName] && vm.models[modelName].map(partner => ({
            key: partner.id,
            label: partner.short,
        })),
        searchChange: (query) => query && api.client.cancel() && api.partners.dict({ ...searchParams, limit: 200, [params.searchKey || 'short']: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterPublisherSearch (params = {}) {
    return {
        name: 'search',
        placeholder: 'Name or ID',
        label: 'Publisher',
        ...params,
    };
}

export function filterPublisherIdOrName (params = {}, searchParams = {}) {
    const modelId = generateName('filterPublisherIdOrName', params);
    const optionsStored = generateName('filterPublisherIdOrName-all', params);
    const { offerId } = params;
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'partner_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Publisher',
        searchChange: (query) => query && api.client.cancel() && api.partners.dict({ ...searchParams, limit: 200, search: query, offer_id: offerId, ...requestParams })
            .then(({ data }) => {
                if (!data) return;
                let options = data.data.map(publisher => ({
                    key: publisher.id,
                    label: formatItemIdentity(publisher, { infoField: 'short' }),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        parents: 'publisher',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterTrafficSplitter (params = {}) {
    const modelName = generateName('filterSplitter', ...arguments);
    return {
        name: 'splitter_id',
        type: 'multiselect',
        placeholder: 'Smart Link',
        label: 'Smart Link',
        options: () => vm.models[modelName],
        searchChange: (query) => query && api.client.cancel() && api.splitter.splittersList({ limit: 200, [params.searchKey || 'name']: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
        key: 'id',
        text: 'name',
        ...params,
    };
}

export function filterTrafficSplitterSearch (params = {}) {
    return {
        name: 'search',
        placeholder: 'Name or ID',
        label: 'Smart Link',
        ...params,
    };
}

export function filterTrafficSplitterIdOrName (params = {}) {
    const modelId = generateName('filterTrafficSplitterIdOrName', params);
    const optionsStored = generateName('filterTrafficSplitterIdOrName-all', params);
    const { advanced } = params;

    return {
        name: 'splitter_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Smart Link',
        searchChange: (query) => query && api.client.cancel() && api.splitter.splittersList({ limit: 200, search: query, advanced })
            .then(({ data }) => {
                if (!data) return;

                let options = data.data.map(splitter => ({
                    key: splitter.id,
                    label: formatItemIdentity(splitter),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterTriggerSearch (params = {}) {
    return {
        name: 'search',
        placeholder: 'Name or ID',
        label: 'Trigger',
        ...params,
    };
}

export function filterTriggerIdOrName (params = {}) {
    const modelId = generateName('filterTriggerIdOrName', params);
    const optionsStored = generateName('filterTriggerIdOrName-all', params);

    return {
        name: 'trigger_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Trigger',
        searchChange: (query) => query && api.client.cancel() && api.triggers.list({ limit: 200, search: query })
            .then(({ data }) => {
                if (!data) return;

                let options = data.data.map(trigger => ({
                    key: trigger.id,
                    label: formatItemIdentity(trigger),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterPartnerTrafficCountries (params = {}) {
    const modelName = generateName('filterCountry', ...arguments);

    return {
        name: 'partner_traffic_countries',
        placeholder: 'Traffic Countries',
        label: 'Traffic Countries',
        type: 'multiselect',
        multiple: true,
        options: () => vm.models[modelName],
        key: 'code',
        text: 'code',
        optionTemplate: country => country.display_name,
        searchChange: (query) => api.client.cancel() && api.dicts.countries({ display_name: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
            }),
        onInputSelect: () => {
            vm.$set(vm.models, modelName, store.getters.countries);
        },
        ...params,
    };
}

export function filterPartnerTrafficCategories (params = {}) {
    const modelName = generateName('filterPartnerTrafficCategories', ...arguments);

    return {
        name: 'partner_traffic_categories',
        type: 'multiselect',
        multiple: true,
        label: 'Traffic Categories',
        placeholder: 'Traffic Categories',
        options: () => vm.models[modelName],
        key: 'id',
        text: 'name',
        onInputSelect: () => !vm.models[modelName] && api.dicts.categories({ limit: 200 })
            .then(({ data }) => vm.$set(vm.models, modelName, data.data)),
        ...params,
    };
}

export function filterPartnerTrafficTypes (params = {}) {
    const modelName = generateName('filterPartnerTrafficTypes', ...arguments);
    return {
        name: 'partner_traffic_types',
        type: 'multiselect',
        multiple: true,
        label: 'Traffic Types',
        placeholder: 'Traffic Types',
        options: () => vm.models[modelName],
        key: 'name',
        text: 'name',
        onInputSelect: () => !vm.models[modelName] && api.tags.tagsTrafficTypes({ limit: 200 })
            .then(({ data }) => vm.$set(vm.models, modelName, data.data.map(tag => ({ id: tag.id, name: tag.name })))),
        ...params,
    };
}

export function filterOfferTags (params = {}) {
    const modelName = generateName('filterOfferTags', ...arguments);
    const optionsStored = generateName('filterOfferTagsStored', ...arguments);

    return {
        name: 'tag_id',
        type: 'multiselect',
        multiple: true,
        label: 'Tags',
        placeholder: 'Tags',
        options: () => vm.models[modelName],
        optionsStored: () => vm.models[optionsStored],
        key: 'id',
        text: 'value',
        searchChange: (query) => query && api.client.cancel() && api.dicts.offerTags({ limit: 200, value: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        onInputSelect: () => !vm.models[modelName] && api.dicts.offerTags({ limit: 200 })
            .then(({ data }) => {
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        ...params,
    };
}

export function filterOfferLabels (params = {}) {
    const modelName = generateName('filterOfferLabels', ...arguments);
    const optionsStored = generateName('filterOfferLabelsStored', ...arguments);

    return {
        name: 'label_id',
        type: 'multiselect',
        multiple: true,
        label: 'Labels',
        placeholder: 'Labels',
        options: () => vm.models[modelName],
        optionsStored: () => vm.models[optionsStored],
        key: 'id',
        text: 'value',
        searchChange: (query) => query && api.client.cancel() && api.dicts.offerLabels({ limit: 300, value: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        onInputSelect: () => !vm.models[modelName] && api.dicts.offerLabels({ limit: 500 })
            .then(({ data }) => {
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        ...params,
    };
}

export function filterPartnerLabels (params = {}) {
    const modelName = generateName('filterPartnerLabels', ...arguments);
    const optionsStored = generateName('filterPartnerLabelsStored', ...arguments);

    return {
        name: 'label_id',
        type: 'multiselect',
        multiple: true,
        label: 'Labels',
        placeholder: 'Labels',
        options: () => vm.models[modelName],
        optionsStored: () => vm.models[optionsStored],
        key: 'id',
        text: 'value',
        searchChange: (query) => query && api.client.cancel() && api.dicts.partnerLabels({ limit: 300, value: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        onInputSelect: () => !vm.models[modelName] && api.dicts.partnerLabels({ limit: 500 })
            .then(({ data }) => {
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        ...params,
    };
}

export function filterAdvertiserLabels (params = {}) {
    const modelName = generateName('filterAdvertiserLabels', ...arguments);
    const optionsStored = generateName('filterAdvertiserLabelsStored', ...arguments);

    return {
        name: 'label_id',
        type: 'multiselect',
        multiple: true,
        label: 'Labels',
        placeholder: 'Labels',
        options: () => vm.models[modelName],
        optionsStored: () => vm.models[optionsStored],
        key: 'id',
        text: 'value',
        searchChange: (query) => query && api.client.cancel() && api.dicts.advertiserLabels({ limit: 300, value: query })
            .then(({ data }) => {
                if (!data) return;
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        onInputSelect: () => !vm.models[modelName] && api.dicts.advertiserLabels({ limit: 500 })
            .then(({ data }) => {
                vm.$set(vm.models, modelName, data.data);
                vm.$set(vm.models, optionsStored, uniqBy(data.data.concat(vm.models[optionsStored]), params.key || 'id'));
            }),
        ...params,
    };
}

export function filterPartnerType (params = {}) {
    return {
        name: 'type',
        placeholder: 'Publisher type',
        label: 'Publisher type',
        type: 'multiselect',
        multiple: true,
        options: () => store.getters.partnersTypes,
        key: 'string_id',
        text: 'name',
        ...params,
    };
}

export function filterResponsible (params = {}) {
    const modelName = generateName('filterResponsible', ...arguments);
    return {
        name: 'partner_responsible_id',
        placeholder: 'Publisher Manager',
        label: 'Publisher Manager',
        type: 'multiselect',
        multiple: false,
        options: () => vm.models[modelName],
        key: 'key',
        text: 'label',
        onInputSelect: () => !vm.models[modelName] && api.users.dict({ account_type: 1 })
            .then(({ data }) => vm.$set(vm.models, modelName, data.data.map(elem => ({ label: elem.name_ext, key: elem.id })))),
        ...params,
    };
}

export function filterUserName (params = {}) {
    return {
        name: 'name',
        placeholder: 'Username',
        label: 'Username',
        ...params,
    };
}

export function filterUserIdOrName (params = {}) {
    const modelId = generateName('filterUserIdOrName', params);
    const optionsStored = generateName('filterUserIdOrName-all', params);

    return {
        name: 'user_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'User',
        searchChange: (query) => query && api.users.dict({ limit: 200, search: query })
            .then(({ data }) => {
                let options = data.data.map(offer => ({
                    key: offer.id,
                    label: offer.name,
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        parents: 'user',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterEmail (params = {}) {
    return {
        name: 'email',
        placeholder: 'Email',
        label: 'Email',
        ...params,
    };
}

export function filterUserAdmin (params = {}) {
    return {
        name: 'admin',
        type: 'multiselect',
        placeholder: 'Admin status',
        label: 'Admin status',
        options: () => [{ id: 'y', name: 'Only admins' }, { id: 'n', name: 'Not admins' }],
        key: 'id',
        text: 'name',
        ...params,
    };
}

export function filterUserRole (params = {}) {
    const modelName = generateName('filterUserRole', ...arguments);
    return {
        name: 'roles',
        type: 'multiselect',
        multiple: true,
        placeholder: 'Role',
        label: 'Role',
        options: () => vm.models[modelName],
        key: 'role',
        text: 'name',
        onInputSelect: () => !vm.models[modelName] && api.dicts.userRoles()
            .then(({ data }) => vm.$set(vm.models, modelName, data.data)),
        ...params,
    };
}

export function filterVirtualEventType (params = {}) {
    // TODO: this will produce ["filterEventType",{"validate":"required"}]: Array(2)
    // TODO: improve it, identifying filters model by filter function arguments is not very reliable (there can be two filters with same arguments)
    // TODO: also, vm.models[modelName] is not available from the start, so the lable cannot be retrieved from filter.options

    const modelName = generateName('filterVirtualEventType', ...arguments);

    !vm.models[modelName] && store.dispatch('getVirtualEventTypes')
        .then(() => vm.$set(vm.models, modelName, store.getters.virtualEventTypes));

    return {
        name: 'type',
        type: 'multiselect',
        allowEmpty: false,
        clearable: false,
        label: 'KPI',
        options: () => vm.models[modelName] && vm.models[modelName].map(option => ({ ...option, key: option.string_id, label: option.name })),
        key: 'string_id',
        text: 'label',
        ...params,
    };
}

export function filterEventType (params = {}) {
    const modelName = generateName('filterEventType', ...arguments);

    !vm.models[modelName] && store.dispatch('getEventTypesDict')
        .then(() => vm.$set(vm.models, modelName, store.getters.eventTypesDict));

    return {
        name: 'event_type',
        type: 'multiselect',
        allowEmpty: false,
        clearable: false,
        label: 'Event',
        placeholder: 'Event',
        options: () => vm.models[modelName] && vm.models[modelName].map(option => ({ ...option, key: option.string_id, label: option.name })),
        key: 'string_id',
        text: 'label',
        ...params,
    };
}

export function filterTrafficSplitterName (params = {}) {
    return {
        name: 'name',
        placeholder: 'Set name',
        label: 'Set name',
        ...params,
    };
}

export function filterTrafficSplitterUrl (params = {}) {
    return {
        name: 'splitter_url',
        placeholder: 'Tracking URL',
        label: 'Tracking URL',
        ...params,
    };
}

export function filterOnboardingPartnerIdOrName (params = {}) {
    const modelId = generateName('filterOnboardingPartnerIdOrName', params);
    const optionsStored = generateName('filterOnboardingPartnerIdOrName-all', params);

    return {
        name: 'onboarding_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Company',
        searchChange: (query) => query && api.client.cancel() && api.onboarding.dict({ limit: 200, search: query })
            .then(({ data }) => {
                if (!data) return;
                let options = data.data.map(onboarding => ({
                    key: onboarding.id,
                    label: formatItemIdentity(onboarding, { infoField: 'partner_name' }),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        // parents: 'onboarding',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterOnboardingRequestedBy (params = {}) {
    return {
        name: 'requested_by',
        placeholder: 'Requested by',
        label: 'Requested by',
        ...params,
    };
}

export function filterBannersFolderName (params = {}) {
    return {
        name: 'folder_name',
        placeholder: 'Folder name',
        label: 'Folder name',
        ...params,
    };
}

export function filterBannersFileName (params = {}) {
    return {
        name: 'file_name',
        placeholder: 'File name',
        label: 'File name',
        ...params,
    };
}

export function filterKeywordType (params = {}) {
    return {
        name: 'keyword_type',
        placeholder: 'Keyword Type',
        label: 'Keyword Type',
        type: 'multiselect',
        options: () => store.getters.keywordTypes,
        text: 'name',
        key: 'value',
        ...params,
    };
}

export function filterOfferSearch (params = {}) {
    return {
        name: 'search',
        placeholder: 'Name or ID',
        label: 'Offer',
        ...params,
    };
}

export function filterOfferIdOrName (params = {}) {
    const modelId = generateName('filterOfferIdOrName', params);
    const optionsStored = generateName('filterOfferIdOrName-all', params);
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'offer_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Offer',
        searchChange: (query) => query && api.client.cancel() && api.offers.dict({ limit: 200, search: query, ...requestParams })
            .then(({ data }) => {
                if (!data) return;
                let options = data.data.map(offer => ({
                    key: offer.id,
                    label: formatItemIdentity(offer),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        parents: 'offer',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterAdAccountIdOrName (params = {}) {
    //available filters: id[], partner_id, ad_account_id[], ad_account_name, ad_account_type
    const modelId = generateName('filterAdAccountIdOrName', params);
    const optionsStored = generateName('filterAdAccountIdOrName-all', params);
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Ad Account',
        searchChange: (query) => query && api.client.cancel() && api.partners.adAccountDict({ limit: 200, search: query, ...requestParams })
            .then(({ data }) => {
                if (!data) return;
                const options = data.data.map(adAccountItem => ({
                    key: adAccountItem.id,
                    label: adAccountItem.ad_account_name,
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterCompanyAdAccountIdOrName (params = {}) {
    const modelId = generateName('filterCompanyAdAccountIdOrName', params);
    const optionsStored = generateName('filterCompanyAdAccountIdOrName-all', params);
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'search_ad_account',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Ad Account',
        searchChange: (query) => query && api.client.cancel() && api.partners.adAccountDict({ limit: 200, search: query, ...requestParams })
            .then(({ data }) => {
                if (!data) return;
                const options = data.data.map(adAccountItem => ({
                    key: adAccountItem.id,
                    label: adAccountItem.ad_account_name,
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterCampaignIdOrName (params = {}) {
    //available filters: id[], partner_id, campaign_id[], campaign_name, ext_status
    const modelId = generateName('filterCampaignIdOrName', params);
    const optionsStored = generateName('filterCampaignIdOrName-all', params);
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'label',
        label: 'Campaign',
        searchChange: (query) => query && api.client.cancel() && api.partners.campaignsDict({ limit: 200, search: query, ...requestParams })
            .then(({ data }) => {
                if (!data) return;

                let options = data.data.map(adAccountItem => ({
                    key: adAccountItem.id,
                    label: formatItemIdentity(adAccountItem, { infoField: 'campaign_name' }),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}


export function filterExternalStatus (params = {}) {
    return {
        name: 'ext_status',
        placeholder: 'External Status',
        label: 'External Status',
        type: 'multiselect',
        multiple: false,
        options: () => store.getters.extCampaignStatuses.map(elem => ({ label: elem.name, key: elem.code })),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterPaused (params = {}) {
    return {
        name: 'paused',
        placeholder: 'Active or Paused',
        label: 'Status',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'Active' },
            { key: 1, label: 'Paused' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterOffersFeatured (params = {}) {
    return {
        name: 'featured',
        placeholder: 'Featured or Not',
        label: 'Featured',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'No' },
            { key: 1, label: 'Yes' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterResults (params = {}) {
    return {
        name: 'filter_results_local',
        placeholder: 'Active or All',
        label: 'Filter results',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'All' },
            { key: 1, label: 'Active' },
        ],
        key: 'key',
        text: 'label',
        labelInfo: 'This controls the results shown in the filter fields when filtering for Offer/Advertiser/Publisher. ' +
            'Active means you will be limited to Active Entries when filtering',
        ...params,
    };
}

export function filterOfferCapsReached (params = {}) {
    return {
        name: 'caps_reached',
        placeholder: 'Caps Reached',
        label: 'Caps Reached',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'No' },
            { key: 1, label: 'Yes' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterAlert (params = {}) {
    return {
        name: 'alert',
        placeholder: 'Has an alert',
        label: 'Offers with an alert',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'No Alert' },
            { key: 1, label: 'Alert' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}


export function filterFraudReason (params = {}) {
    return {
        name: 'vetting_strategy_id',
        placeholder: 'Fraud Reason',
        label: 'Fraud Reason',
        type: 'multiselect',
        multiple: true,
        options: () => store.getters.fraudReasons,
        key: 'string_id',
        text: 'name',
        ...params,
    };
}

export function filterTrafficSplitterType (params = {}) {
    return {
        name: 'type',
        placeholder: 'Type',
        label: 'Type',
        type: 'multiselect',
        options: () => store.getters.splittersTypes,
        key: 'code',
        text: 'name',
        ...params,
    };
}
export function filterScheduleStatus (params = {}) {
    return {
        name: 'status',
        placeholder: 'Scheduler Status',
        label: 'Scheduler Status',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 'pending', label: 'Pending' },
            { key: 'success', label: 'Success' },
            { key: 'failed', label: 'Failed' },
            { key: 'processing', label: 'Processing' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterApprovalEventStatuses (params = {}) {
    return {
        name: 'approval_status',
        placeholder: 'Approval status',
        label: 'Approval status',
        type: 'multiselect',
        options: () => store.getters.approvalEventStatuses,
        key: 'code',
        text: 'name',
        multiple: true,
        ...params,
    };
}

export function filterAdvertiserPostbackStatus (params = {}) {
    return {
        name: 'status',
        placeholder: 'Status',
        label: 'Status',
        type: 'multiselect',
        multiple: false,
        allowEmpty: false,
        clearable: false,
        validate: 'required',
        options: () => store.getters.advertiserPostbackStatuses,
        key: 'code',
        text: 'name',
        ...params,
    };
}

export function filterSKAdNetwork (params = {}) {
    return {
        name: 'has_application',
        placeholder: 'SKAdNetwork',
        label: 'SKAdNetwork',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'No' },
            { key: 1, label: 'Yes' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterApplicationIdOrName (params = {}) {
    const modelId = generateName('filterApplicationIdOrName', params);
    const optionsStored = generateName('filterApplicationIdOrName-all', params);
    const requestParams = isObject(params.requestParams) ? { ...params.requestParams } : {};

    return {
        name: 'application_search',
        placeholder: 'Name or ID',
        key: 'key',
        text: 'name',
        label: 'Application',
        searchChange: (query) => query && api.client.cancel() && api.applications.list({ limit: 200, search: query, ...requestParams })
            .then(({ data }) => {
                if (!data) return;
                let options = data.data.map(application => ({
                    key: application.id,
                    name: formatItemIdentity(application),
                }));

                vm.$set(vm.models, modelId, options);
                vm.$set(vm.models, optionsStored, uniqBy(options.concat(vm.models[optionsStored]), 'key'));
            }),
        options: () => vm.models[modelId],
        optionsStored: () => vm.models[optionsStored],
        parents: 'application',
        type: 'multiselect',
        multiple: true,
        taggable: true,
        ...params,
    };
}

export function filterActiveTraffic (params = {}) {
    return {
        name: 'traffic_only',
        placeholder: 'Active traffic',
        label: 'Active traffic',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterUrlPath (params = {}) {
    return {
        name: 'url_path',
        placeholder: 'URL path',
        label: 'URL path',
        type: 'multiselect',
        multiple: false,
        key: 'code',
        text: 'name',
        ...params,
    };
}

export function filterEventErrorCode (params = {}) {
    return {
        name: 'event_error_code',
        placeholder: 'Error code',
        label: 'Error code',
        type: 'multiselect',
        multiple: true,
        options: () => store.getters.eventErrorCodes,
        key: 'code',
        text: 'description',
        ...params,
    };
}

export function filterBillingCustomerId (params = {}) {
    return {
        name: 'billing_customer_id',
        placeholder: 'Customer ID',
        label: 'Customer ID',
        ...params,
    };
}

export function filterBillingVendorId (params = {}) {
    return {
        name: 'billing_vendor_id',
        placeholder: 'Vendor ID',
        label: 'Vendor ID',
        ...params,
    };
}

export function filterCreatedByOptimizations (params = {}) {
    return {
        name: 'only_created_by_optimizations',
        placeholder: 'Only created by optimizations',
        label: 'Only created by optimizations',
        type: 'switch',
        activeValue: 1,
        activeText: 'Enabled',
        inactiveValue: null,
        ...params,
    };
}

export function filterOfferDateRange (params = {}) {
    return {
        name: 'offer_created_time_range',
        placeholder: 'Offer created time range',
        label: 'Offer created time range',
        type: 'multiselect',
        options: () => store.getters.offerCreatedTimeRange,
        key: 'code',
        text: 'name',
        ...params,
    };
}

export function filterAnalyticsKPIType (params = {}) {
    return {
        name: 'type',
        placeholder: 'Type',
        label: 'Type',
        type: 'multiselect',
        options: () => store.getters.analyticsKPITypes,
        key: 'code',
        text: 'name',
        ...params,
    };
}

export function filterAudiences (params = {}) {
    return {
        name: 'with_audiences',
        placeholder: 'Audiences',
        label: 'Audiences',
        type: 'multiselect',
        multiple: false,
        options: () => [
            { key: 0, label: 'No' },
            { key: 1, label: 'Yes' },
        ],
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterAdAccountType (params = {}) {
    return {
        name: 'ad_account_type',
        placeholder: 'Platform',
        label: 'Platform',
        type: 'multiselect',
        options: () => store.getters.extCampaignTypes.map(elem => ({ label: elem.name, key: elem.code })),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterExtCampaignType (params = {}) {
    return {
        name: 'campaign_type',
        placeholder: 'Platform',
        label: 'Platform',
        type: 'multiselect',
        options: () => store.getters.extCampaignTypes.map(elem => ({ label: elem.name, key: elem.code })),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterOrganizationId (params = {}) {
    return {
        name: 'organization_id',
        placeholder: 'Organization ID',
        label: 'Organization ID',
        ...params,
    };
}

export function filterRevenuesGroup (params = {}) {
    return {
        name: 'revenues_group',
        placeholder: 'Company',
        label: 'Company',
        type: 'multiselect',
        options: () => store.getters.revenuesGroups.map(elem => ({ label: elem.name, key: elem.code })),
        key: 'key',
        text: 'label',
        ...params,
    };
}

export function filterForeignLeadSources (params = {}) {
    return {
        name: 'source',
        placeholder: 'Source',
        label: 'Source',
        type: 'multiselect',
        options: () => store.getters.foreignLeadSources.map(elem => ({ label: elem.name, key: elem.code })),
        key: 'key',
        text: 'label',
        ...params,
    };
}
